import { ca } from '@cian/analytics';
import { EDealType, EEntityType, EOrderField } from '../../types/filters';

export const trackShowFilters = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_filter',
    category: 'ListingFavorites',
  });
};

export const trackApplyFilters = (dealType: EDealType | null, entityType: EEntityType | null) => {
  const entityTypeLabel = entityType === EEntityType.Residential ? 'flat_other' : entityType;

  ca('eventSite', {
    name: 'oldevent',
    action: 'apply_filter',
    category: 'ListingFavorites',
    label: `${dealType || 'other'}, ${entityTypeLabel || 'other'}`,
  });
};

export const trackSortOrder = (order: EOrderField) => {
  const orderLabel = {
    [EOrderField.Added]: 'date_added',
    [EOrderField.Created]: 'date_pub',
    [EOrderField.Price]: 'price_asc',
  };

  ca('eventSite', {
    name: 'oldevent',
    action: 'sorting',
    category: 'ListingFavorites',
    label: orderLabel[order],
  });
};
